export default __webpack_public_path__ + "static/media/cert-general-staff-a-consumer-sc.06ecd081.jpg";